import {
  SET_LOADING
} from './mutations-type'

var _ = require('lodash');

// initial state
const state = {
  loading: false,
  appVersion: "1.6.0",
}

// mutations
const mutations = {
  [SET_LOADING](state, message) {
    state.loading = message;
  },
}

const actions = {
  setLoading({ commit }, msg) {
    commit(SET_LOADING, msg)
  }
}

const getters = {
  getLoading: function () {
    return state.loading;
  },
  getProdVersion: state => {
    return state.appVersion;
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/store-app.js